<template>
  <div v-on-clickaway="away" class="relative">
    <button @click="toggle" class="text-gray-900 flex flex-row items-center text-sm font-semibold bg-transparent rounded-lg px-3 py-2 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200">
      <span class="cursor-pointer flex items-center i18n-locale gap-1">
        
        <img class="h-4 w-5 blob green" :src="country_img || 'https://img.icons8.com/material-outlined/2x/image.png' " :alt="country_data.code" />
        
        <span class="hidden sm:block ml-2">{{ country_data.name }}
          <sup v-if="currency" class="font-bold uppercase">({{ currency }})</sup>
        </span>
        
        <span v-if="!open">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>
        </span>
      
        <span v-else>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
          </svg>
        </span>

      </span>
    </button>

    <div v-if="open" x-transition:enter="transition ease-out duration-100" x-transition:enter-start="transform opacity-0 scale-95" x-transition:enter-end="transform opacity-100 scale-100" x-transition:leave="transition ease-in duration-75" x-transition:leave-start="transform opacity-100 scale-100" x-transition:leave-end="transform opacity-0 scale-95" class="absolute right-20 w-full mt-2 origin-top-right rounded-md shadow-lg md:w-60">
      <div class="w-max md:w-full p-1 lg:p-2 bg-white rounded-md shadow vs-dropdown--menu">
        <li v-for="(item, index) in warehousesAll" :key="index" @click="changeWrahouse(item.code)" class="text-gray-900 hover:text-primary-500 vs-dropdown--item">
          <a class="vs-dropdown--item-link"><img class="h-4 w-5 mr-1" :src="$f.getCountryCode(item.code)" :alt="item.code" />
            &nbsp;{{ item.name }}
            <div class="checkboxWrapper">
              <span style="font-size: 20px;" v-if="country_data.code == item.code">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
              </span>
            </div>
          </a>
        </li>
      </div>

      <div class="vs-dropdown--menu--after"></div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
export default {
  mixins: [clickaway],
  data() {
    return {
      open: false,
      options: this.$countries,
      country_img: '',
      warehousesAll: [],
      country_data: {},
      currency: '',
    };
  },
  async mounted() {
    this.warehousesAll = await this.warehouses;
    await this.getCurrency();
    this.country_img = await this.country_locale_img;
    this.country_data = await this.getCurrentLocaleData;
  },
  computed: {
    async warehouses() {
      return this.$store.getters['wharhouse/warehouses'];
    },
    async warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
    async country_locale_img() {
      return this.$f.getCountryCode(await this.warhouseSelected);
    },
    async getCurrentLocaleData() {
      return {
        name: this.$f.getCountryNameByCode(
          this.options,
          await this.warhouseSelected,
        ),
        code: await this.warhouseSelected,
      };
    },
  },
  watch: {
    warhouseSelected: async function (oldVal, newVal) {
      await this.getCurrency();
    },
  },
  methods: {
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then(res => {
        this.currency = res;
      });
    },
    async getWarehouses() {
      await this.$store.dispatch('wharhouse/getWarehouses').then(res => {
        this.warehousesAll = res;
      });
    },
    async changeWrahouse(value) {
      this.$store.dispatch('wharhouse/changeWrahouse', { warhouse: value });

      this.country_img = await this.country_locale_img;
      this.country_data = await this.getCurrentLocaleData;
      localStorage.setItem('countryW', value);
      this.open = false;
    },
    async toggle() {
      this.open = !this.open;
      this.country_data = await this.getCurrentLocaleData;
      await this.getWarehouses();
      await this.getCurrency();
    },
    away() {
      this.open = false;
    },
  },
};
</script>
<style scoped>
.blob.green {
  background: rgba(51, 217, 178, 1);
  box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
  animation: pulse-green 2s infinite;
}

@keyframes pulse-green {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
  }
}

.vs-dropdown--item {
  text-align: left;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  position: relative;
  z-index: 100;
  border-radius: 5px;
  width: calc(100% - 6px);
  margin: 0 3px;
  list-style: none;
  font-weight: 400 !important;
  font-size: 0.9375em;
}

.vs-dropdown--item-link {
  display: flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: justify;
  justify-content: space-between;
  padding: 5px 1px;
  cursor: pointer;
}

.vs-dropdown--menu {
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
}

.vs-dropdown--menu--after {
  top: 0;
  right: 30px;
  position: absolute;
  width: 10px;
  height: 10px;
  display: block;
  background: #fff;
  -webkit-transform: rotate(45deg) translate(-7px);
  transform: rotate(45deg) translate(-7px);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 10;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.checkboxWrapper {
  height: 20px;
  width: 20px;
  margin-left: 10px;
}
</style>
